
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sellos/[...slug]",
      function () {
        return require("private-next-pages/sellos/[...slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sellos/[...slug]"])
      });
    }
  